import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import Alert from '../core/alertNotification/Alert';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IAlertsLoaderProps {}

export default function AlertsLoader(props: IAlertsLoaderProps) {
    const success = useAlertsStore((state) => state.success);
    const warning = useAlertsStore((state) => state.warning);
    const error = useAlertsStore((state) => state.error);

    return (
        <>
            {error && <Alert severity="error" message={error} />}
            {success && <Alert severity="success" message={success} />}
            {warning && <Alert severity="warning" message={warning} />}
        </>
    );
}
